import React,{useEffect, useRef} from "react";
import NavBar from "../components/NavBar";
import Himg from "../assets/test.avif"
import Logo from "../assets/Logo_e.png"
import img1 from "../assets/G_Uni.svg"
import img2 from "../assets/Buni.svg"
import img3 from "../assets/LSU.svg"
import img4 from "../assets/SUni.svg"
import img5 from "../assets/LUni.svg"
import imguni from "../assets/Universities.png"
import FAQ from "../components/FAQ.jsx";
import Footer from "../components/Footer.jsx";
import HomeSec2 from "../components/HomeSec2.jsx";
import HomeSec3 from "../components/HomeSec3.jsx";
import Bar from "../components/Bar.jsx";
import SmoothScroll from "../components/Lenis.jsx";
import gsap from "gsap"

const Home = ()=>{
    SmoothScroll()

    const title = useRef(null);
    const title2 = useRef(null);
    // const bar = useRef(null);
    const sub = useRef(null);
    const button = useRef(null);
    const img = useRef(null);
    const trust = useRef(null);
    const imgsection = useRef(null);


    useEffect(()=>{
        gsap.set([title.current,title2.current,sub.current,button.current,img.current,trust.current,imgsection.current],{
            opacity:0,
            y:100,
        });
        gsap.to([img.current,title.current,title2.current,sub.current,button.current,trust.current,imgsection.current],{
            opacity:1,
            y:0,
            duration:2,
            stagger:0.3,
            ease:"power3.out",
        })
    },[]);

    return(
        <div className="bg-black overflow-hidden">
        <NavBar />
        <section className="w-full font-guton pt-10 md:pt-20 xl:pt-28 bg-whiteExtra pb-10 md:pb-20">
            <div className="w-90 mx-auto flex flex-col items-center md:items-start max-w-[1440px]">
            <Bar />
            <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
                <div className="flex flex-col w-95 md:w-55 mt-5 md:mt-10 leading-70">
                    <p ref={title} className="text-40 leading-40 tracking-[-2px] font-bold bg-custom-gradient text-transparent bg-clip-text md:text-44 md:leading-45 lg:text-60 lg:leading-55 xl:text-80 xl:leading-70">The Easy Way to 
                    Study Abroad</p>
                    <p ref={title2} className="font-bold text-black tracking-[-1px] text-40 leading-40 md:text-44 md:leading-40 lg:text-60 lg:leading-55 xl:text-80 xl:leading-70"><span className="hidden md:inline-block align-middle"><img src={Logo} alt="Logo" className="h-8 md:h-8 lg:h-10 xl:h-16" /></span><span className="align-middle md:leading-40 lg:leading-55"> Your Education Consultant.</span></p>
                    <p ref={sub} className="text-12 leading-12 md:text-14 md:leading-14 mt-2 mb-2 tracking-[-0.6px] md:tracking-[-1px] md:text-14 lg:mb-4 lg:text-20 lg:leading-21 xl:text-24 xl:leading-24 xl:tracking-[0px]">From securing university acceptance to guiding you through visas, housing and work opportunities. <strong>The First Step to Studying Abroad Begins Here.</strong></p>
                    <div ref={button} className="hidden md:block flex w-fit text-14 lg:text-20 xl:text-25">
                        <a href="https://wa.link/eaoxxu" target="_blank" rel="noopener noreferrer" className="flex font-guton font-bold bg-custom-gradient text-white px-3 rounded-full py-1 leading-24 lg:px-4 lg:py-2 xl:px-6 xl:py-3 hover:bg-custom-hover-gradient transition duration-500 ease-in-out">Start Your Journey</a></div>
                    <div className="block md:hidden w-95 mx-auto ml-[-7px]">
                        <img src={Himg} alt="Logo" />
                    </div>
                    <p ref={trust} className="text-14 md:text-16 leading-24 mt-6 mb-2 lg:mt-6 lg:text-20">Trusted by Universities around Poland</p>
                    <div ref={imgsection} className="flex justify-center md:justify-start md:w-95 lg:w-90 xl:w-70">
                        <img src={imguni} alt="" className="w-65 md:w-55 lg:w-55 xl:w-70" />
                        {/* <img src={img2} alt="" className="w-[25px] md:w-[27px] lg:w-[50px] xl:w-[74px]"/>
                        <img src={img3} alt="" className="w-[58px] md:w-[80px] lg:w-[90px] xl:w-[108px]"/>
                        <img src={img4} alt="" className="w-[25px] md:w-[27px] lg:w-[35px] xl:w-[48px]"/>
                        <img src={img5} alt="" className="w-[95px] md:w-[101px] lg:w-[135px] xl:w-[177px]"/> */}
                    </div>
                </div>
                <div ref={img} className="hidden md:block w-45">
                    <img src={Himg} alt="Logo" />
                </div>
            </div>
            </div>
        </section>

        <HomeSec2 />
        {/* section 3 */}
        <HomeSec3 />
        {/* FAQ */}
        <FAQ />
        <Footer />
        </div>
    )
}

export default Home;